<div style="display: inline-block;width: 100%;height: auto;">
    <div style="width: 100%; float: left; padding-left: 20px;box-sizing: border-box;">
        <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
            <div class="form-group col-4-div wrapper_label" style="padding-right: 10px;box-sizing: border-box;">
                <label>Pujan Qr Code*</label>
                <textarea #autofocus class="form-control border-primary" rows="1" minlength="6" maxlength="26" type="text"
                    (ngModelChange)="changeSearchValue()" placeholder="Enter Booking No." [(ngModel)]="bookingNo" name="bookingNo"></textarea>
                <div class="inaild_no" *ngIf="errorMsg">{{errorMsg}}</div>
            </div>
        </ul>
        <div class="card" *ngIf="visitorDetails">
            <div class="card-body upper-header">
                <ul 
                    style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;margin-top: 50px;">
                    <li class="wrapper_label">
                            <label>Booking No.</label>
                            <small>{{visitorDetails?.booking_no}}</small>
                        </li>

                        <li class="wrapper_label">
                            <label>Name</label>
                            <small>{{visitorDetails?.name}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Mobile Number</label>
                            <small>{{visitorDetails?.mobile_no}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Puja Type</label>
                            <small>{{visitorDetails?.puja_type}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Date of Puja</label>
                            <small>{{visitorDetails?.date_of_puja | date:'dd-MM-yyyy'}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Amount</label>
                            <small>{{visitorDetails?.amount}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Payment Status</label>
                            <small>{{visitorDetails?.payment_status}}</small>
                        </li>
                        <li class="wrapper_label">
                            <label>Pujari Name</label>
                            <small>{{visitorDetails?.pujari_name}}</small>
                        </li>
                </ul>
                <div style="text-align: center;color: green;" *ngIf = "successMsg">
                    {{successMsg}}
                </div>
            </div>
        </div>

        <div class="p-12"
        *ngIf="bookingNo && !visitorDetails && !loading && !errorMsg">
           <span class="ng-star-inserted no_data">No Data found.</span>
         </div>
        <div  class="mt-4" *ngIf="visitorDetails">
            <button class="btn btn-primary btn-fw top-btn-head" (click)="verify()">Next</button>
        </div>
    </div>
</div>